import { render, staticRenderFns } from "./StandupAdmin.vue?vue&type=template&id=6609ed65&scoped=true&"
import script from "./StandupAdmin.vue?vue&type=script&lang=js&"
export * from "./StandupAdmin.vue?vue&type=script&lang=js&"
import style0 from "./StandupAdmin.vue?vue&type=style&index=0&id=6609ed65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6609ed65",
  null
  
)

export default component.exports